import React from 'react';
import i18next from 'i18next';
import cn from 'classnames';
import { numberWithSpaces } from '../../../../utils';

export default class ExchangeResult extends React.PureComponent {
  render() {
    const { currency = 'REX', usd, amount, format = true, className } = this.props;
    return (
      <div className={cn('exchange-result', className)}>
        <span className="exchange-result__title">
          {i18next.t('crypto_exchange.title')}
        </span>
        <span className="exchange-result__value">
          <span className="exchange-result__tilda">~</span>{' '}
          {typeof amount === 'number'
            ? format
              ? numberWithSpaces(amount)
              : amount
            : 0}{' '}
          <span className="exchange-result__currency">{currency}{' '}{' '}</span>
            <span className="exchange-result__tilda">~</span>{' '}
          {typeof usd === 'number'
            ? format
              ? numberWithSpaces(usd)
              : usd
            : 0}{' '}
          <span className="exchange-result__currency">USD</span>
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Crypto/CryptoCalc/ExchangeResult/ExchangeResult.jsx